import { render, staticRenderFns } from "./EditFakturPage.vue?vue&type=template&id=a3611a98&"
import script from "./EditFakturPage.vue?vue&type=script&lang=js&"
export * from "./EditFakturPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports